import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { diets } from '../mock';
import { Button } from './ui/button';
import { ArrowUpRight } from 'lucide-react';

const categories = ['All', 'Weight', 'Hormonal', 'Medical', 'Pregnancy', 'Performance'];
const catMap = {
  All: () => true,
  Weight: (d) => /weight|maintenance/i.test(d.name),
  Hormonal: (d) => /pcod|pcos|menopause/i.test(d.name),
  Medical: (d) => /diabet|hypertension|infertility|celiac|anaemic/i.test(d.name),
  Pregnancy: (d) => /pregnancy|wedding/i.test(d.name),
  Performance: (d) => /body|pre-wedding/i.test(d.name),
};

const Services = ({ onBook }) => {
  const [active, setActive] = useState('All');
  const nav = useNavigate();
  const filtered = diets.filter(catMap[active]);

  return (
    <section id="services" className="py-24 bg-[#faf7f1]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 gap-6">
          <div>
            <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Programs</div>
            <h2 className="font-serif text-4xl lg:text-5xl text-[#1a2b17] tracking-tight max-w-xl">
              Specialised diet plans for every goal
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 rounded-full text-sm border transition-all ${
                  active === c
                    ? 'bg-[#1a2b17] text-white border-[#1a2b17]'
                    : 'bg-white text-[#1a2b17] border-neutral-200 hover:border-[#1a2b17]'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((d) => (
            <div
              key={d.id}
              className="group bg-white rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={d.image}
                  alt={d.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full text-xs font-medium text-[#1a2b17]">
                  ₹{d.price}
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-serif text-xl text-[#1a2b17]">{d.name}</h3>
                  <div className="w-9 h-9 rounded-full bg-[#faf7f1] group-hover:bg-[#3a5a2c] group-hover:text-white flex items-center justify-center transition">
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </div>
                <p className="text-sm text-[#4a5544] mt-3 leading-relaxed">{d.desc}</p>
                <button
                  onClick={onBook}
                  className="mt-5 text-sm text-[#c9743a] font-medium hover:underline underline-offset-4"
                >
                  Enroll now →
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-14">
          <Button
            onClick={() => nav('/quiz')}
            className="h-13 px-8 rounded-full bg-[#3a5a2c] hover:bg-[#2d4622] text-white py-4"
          >
            Not sure? Take our 2-min diet quiz
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
